'use client';

import { useCallback } from 'react';

import { useStoreRedirect as useSharedStoreRedirect } from '@web-store-platforms/hooks/use-store-redirect';
import { ELocalStorageKeys } from '@web-store-platforms/types';
import { usePathname } from 'next/navigation';

import { useLogin } from '@/api/useLogin';
import { useLoginState } from '@/state/hooks/login.state.hook';
import { webStorageUtil } from '@/state/webStorage.state.service';
import { reportStoreRedirectEvent } from './storeRedirectTelemetry';

export const useStoreRedirect = () => {
  const pathname = usePathname();
  const { getRedirectToken } = useLogin();
  const { isLoggedIn } = useLoginState();

  const fetchRedirectToken = useCallback(async (): Promise<string> => {
    const { data } = await getRedirectToken.mutateAsync();
    return data.token;
  }, [getRedirectToken]);

  const setAutoCollectFlag = useCallback((): void => {
    webStorageUtil.set(ELocalStorageKeys.AUTO_COLLECT_FLAG, 'true');
  }, []);

  const onRedirectEvent = useCallback(
    (event: Parameters<typeof reportStoreRedirectEvent>[0]): void => {
      reportStoreRedirectEvent(event, pathname);
    },
    [pathname]
  );

  return useSharedStoreRedirect({
    getRedirectToken: fetchRedirectToken,
    isLoggedIn,
    onRedirectEvent,
    setAutoCollectFlag,
  });
};
